import styled from 'styled-components'

const BODY_LINE_HEIGHT = 1.5
const BODY_LINES = 8

export const BodyStyled = styled.div`
  line-height: ${BODY_LINE_HEIGHT};

  display: -webkit-box;
  -webkit-line-clamp: ${BODY_LINES};
  -webkit-box-orient: vertical;
  overflow: hidden;

  p,
  ul,
  ol,
  blockquote {
    margin: 0 0 ${(props) => props.theme.space.medium};

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    padding-left: ${(props) => props.theme.space.large};
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }

  li {
    margin-bottom: ${(props) => props.theme.space.xsmall};
  }

  a {
    color: ${(props) => props.theme.colors.textLink};
    text-decoration: underline;
  }

  strong,
  b {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  em,
  i {
    font-style: italic;
  }
`
